import { ReloadIcon } from './ReloadIcon';

/**
 * author: Austin Andrews
 * id 8E25B2CE-4DAF-4BD1-9D3F-27F86DA55D21
 * name reload
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/reload.svg
 * tags
 * - Automotive 
 * - Arrow 
 */
export const RotateClockwiseIcon = ReloadIcon;
export default RotateClockwiseIcon